// import React, { useState } from 'react'
import { useEffect, useState } from 'react'
import { toast } from 'react-hot-toast'
import { useParams } from 'react-router-dom'
import axiosConfig from '~/api/axios-config'
import Carts from '~/components/Cart/Carts'

const FindProduct = () => {
	const [products, setProducts] = useState([])
	// const [loading, setLoading] = useState({ redering: true })
	const params = useParams()
	const product = params.product.trim()

	useEffect(() => {
		axiosConfig
			.get(`/products/search`, {
				params: { search: product },
			})
			.then((res) => setProducts(res.data.products))
			.catch((err) => console.log(err))
	}, [product])

	return (
		<section className='bg-white p-8'>
			<h1 className='ss-title py-4 text-xxl font-bold mt-[5rem]'>
				Có {products.length} kết quả tìm kiếm của: "{product}"
			</h1>
			<div className=''>
				<Carts cartList={products} />
			</div>
		</section>
	)
}

export default FindProduct
